var map = {
	"./shape-square-aquamarine-gradient.png": 50294,
	"./shape-square-aquamarine-light.png": 88317,
	"./shape-square-aquamarine.png": 74952,
	"./shape-square-blue-gradient.png": 96439,
	"./shape-square-blue-light.png": 35030,
	"./shape-square-blue.png": 13533,
	"./shape-square-cyan-gradient.png": 62048,
	"./shape-square-cyan-light.png": 39165,
	"./shape-square-cyan.png": 97683,
	"./shape-square-green-gradient.png": 8852,
	"./shape-square-green-light.png": 35483,
	"./shape-square-green.png": 20822,
	"./shape-square-grey100.png": 81963,
	"./shape-square-grey1000.png": 52448,
	"./shape-square-grey200.png": 18526,
	"./shape-square-grey25.png": 65649,
	"./shape-square-grey300.png": 94998,
	"./shape-square-grey400.png": 87657,
	"./shape-square-grey50.png": 98960,
	"./shape-square-grey500.png": 92656,
	"./shape-square-grey600.png": 56515,
	"./shape-square-grey700.png": 13002,
	"./shape-square-grey800.png": 18996,
	"./shape-square-grey900.png": 51472,
	"./shape-square-indigo-gradient.png": 36980,
	"./shape-square-indigo-light.png": 83650,
	"./shape-square-indigo.png": 31074,
	"./shape-square-lime-gradient.png": 33339,
	"./shape-square-lime-light.png": 80755,
	"./shape-square-lime.png": 14743,
	"./shape-square-magenta-gradient.png": 11567,
	"./shape-square-magenta-light.png": 54284,
	"./shape-square-magenta.png": 88018,
	"./shape-square-navy-gradient.png": 95655,
	"./shape-square-navy-light.png": 30883,
	"./shape-square-navy.png": 30336,
	"./shape-square-orange-gradient.png": 94232,
	"./shape-square-orange-light.png": 54652,
	"./shape-square-orange.png": 90595,
	"./shape-square-purple-gradient.png": 76518,
	"./shape-square-purple-light.png": 93103,
	"./shape-square-purple.png": 67109,
	"./shape-square-red-gradient.png": 98253,
	"./shape-square-red-light.png": 31350,
	"./shape-square-red.png": 15024,
	"./shape-square-yellow-gradient.png": 73366,
	"./shape-square-yellow-light.png": 88040,
	"./shape-square-yellow.png": 4665
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77026;